import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-afe3843c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pager" }
const _hoisted_2 = { key: 1 }

import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { resourceKind, resourceTitle, useLearningPathI18n } from '../view/learningPath';
import type { INavEntry } from './usePathwayItemNav';


export default /*#__PURE__*/_defineComponent({
  props: {
    prev: null,
    next: null,
    hrefOf: null,
    pathwayHref: null
  },
  setup(__props: any) {



const { tl } = useLearningPathI18n();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (__props.prev)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: __props.hrefOf(__props.prev),
          class: "lp-card pager__link"
        }, {
          default: _withCtx(() => [
            _createVNode(HcIcon, {
              name: "chevron-left",
              size: 18
            }),
            _createElementVNode("span", null, [
              _createElementVNode("small", null, _toDisplayString(_unref(tl)('previous')) + " · " + _toDisplayString(_unref(tl)(`type_${_unref(resourceKind)(__props.prev.resource)}`)), 1),
              _createElementVNode("strong", null, _toDisplayString(_unref(resourceTitle)(__props.prev.resource)), 1)
            ])
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_2)),
    (__props.next)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          to: __props.hrefOf(__props.next),
          class: "lp-card pager__link pager__link--next"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createElementVNode("small", null, _toDisplayString(_unref(tl)('next')) + " · " + _toDisplayString(_unref(tl)(`type_${_unref(resourceKind)(__props.next.resource)}`)), 1),
              _createElementVNode("strong", null, _toDisplayString(_unref(resourceTitle)(__props.next.resource)), 1)
            ]),
            _createVNode(HcIcon, {
              name: "chevron-right",
              size: 18
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 3,
          to: __props.pathwayHref,
          class: "lp-card pager__link pager__link--next"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createElementVNode("small", null, _toDisplayString(_unref(tl)('path_end')), 1),
              _createElementVNode("strong", null, _toDisplayString(_unref(tl)('back_to_path')), 1)
            ]),
            _createVNode(HcIcon, {
              name: "chevron-right",
              size: 18
            })
          ]),
          _: 1
        }, 8, ["to"]))
  ]))
}
}

})